import favorites from './favorites';

export default favorites;
